export const INDENT_STRING = '\t';
export const NEWLINE_STRING = '\n';
export const DATA_COLUMNS = 68;
export const INDENT_ROOT = false;
//# sourceMappingURL=options.mjs.map